__turbopack_context__.v({
  "className": "lato_4f29b48-module__ons6zq__className",
  "variable": "lato_4f29b48-module__ons6zq__variable",
});
